<template>
  <div>
    <h1>Repositório <span v-if="acs[acselecionada].nome != 'ACT SOLUTI'">AC</span> {{ acs[acselecionada].nome }}</h1>
    <div class="texto" v-if="acs[acselecionada].mensagem_intro">
      <p>{{acs[acselecionada].mensagem_intro}}</p>
      <br>
    </div>
    <template v-if="acs[acselecionada].referencia">

      <template v-if="acs[acselecionada].referencia.imagem">
        <img :src="acs[acselecionada].referencia.imagem" style="border: none;">
        <br><br><br>
      </template>

      <ul class="lista-downloads">
        <li class="prod">{{ acs[acselecionada].referencia.titulo }}</li>

        <li v-for="link in acs[acselecionada].referencia.links">
          <a :href="link.link" target="_blank">{{ link.nome }}</a>
          <br>
          <span v-html="link.descricao"></span>
		    </li>
      </ul>

    </template>

    <ccd-repositorio-cadeia v-if="acs[acselecionada].cadeias"
      :nomeac="acs[acselecionada].nome"
      :cadeias="acs[acselecionada].cadeias"
    ></ccd-repositorio-cadeia>

    <ccd-repositorio-docs v-if="acs[acselecionada].documentos"
      :nomeac="acs[acselecionada].nome"
      :docs="acs[acselecionada].documentos"
    ></ccd-repositorio-docs>

    <ul v-if="acs[acselecionada].pss" class="lista-downloads">
      <li class="prod">PSS - Prestadores de Serviço de Suporte</li>
      <li v-for="pss in acs[acselecionada].pss">
        <a :href="pss.link" target="_blank">{{ pss.nome }}</a>
        <span>{{ pss.descricao }}</span>
      </li>
    </ul>

    <div v-if="acs[acselecionada].nome != 'ACT SOLUTI'">
      <ccd-repositorio-ar
        :acselecionada="acselecionada"
      ></ccd-repositorio-ar>

      <ccd-repositorio-acordo
        :acselecionada="acselecionada"
      ></ccd-repositorio-acordo>
    </div>

  </div>
</template>

<script>
import { EventBus } from '../main';
import RepositorioCadeia from './RepositorioCadeia.vue';
import RepositorioDocs from './RepositorioDocs.vue';
import RepositorioAR from './RepositorioAR.vue';
import RepositorioAcordo from './RepositorioAcordo.vue';

export default {
  props: [
    'acselecionada'
  ],
  components: {
    'ccd-repositorio-cadeia': RepositorioCadeia,
    'ccd-repositorio-docs': RepositorioDocs,
    'ccd-repositorio-ar': RepositorioAR,
    'ccd-repositorio-acordo': RepositorioAcordo
  },
  computed: {
    acs() {
      //console.log('Computed: Repositorio acs');
      return EventBus.acs;
    }
  }
}
</script>

<style>
</style>



// WEBPACK FOOTER //
// Repositorio.vue?6d6c8344